import http from "../plugins/axios";
import { AxiosError } from "axios";

import { ArticleModel } from "./contest";

export interface TrackModel {
  imgSrc: string;
  title: string;
  intro: string;
  id: number;
  competition: number;
  prize: number;
  configMaxTeamSize: number;
  configOnlyLeaderSubmit: boolean;
  configTrackStatus: number;
  articles: ArticleModel[];
  stages: number[];
  nowStage: number;
  users: number; times: string;
  tags: string;
  stageTimeline: Record<string, number>;
  stageStartTime: number;
  stageEndTime: number;
  userCount: number;
  teamCount: number;
}
export interface TrackRegistrationModel {
  track: number;
  user: number;
  team?: number | null;
}
export interface TeamMenberModel {
  id: number;
  email: string;
  isLeader: boolean;
}
export interface TeamModel {
  teamName: string;
  id: number;
  track: number;
  schoolName: string;
  region: string;
  leader: number;
  members: TeamMenberModel[];
  giturl: string;
  openSource: string;
}
export interface TeamFeedingForm {
  size: number;
  data: TeamModel[];
}

export function getTrackReg(
  token: string,
  contestId: number,
  trackId: number
): Promise<TrackRegistrationModel | undefined> {
  return new Promise((resolve, reject) => {
    http
      .get(`/api/competition/${contestId}/track/${trackId}/reg`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve(response.data as TrackRegistrationModel);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (
            status === 404 &&
            error.response.data &&
            error.response.data.info
          )
            return resolve(undefined);
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function trackRegister(
  token: string,
  contestId: number,
  trackId: number
): Promise<void> {
  return new Promise((resolve, reject) => {
    http
      .post(
        `/api/competition/${contestId}/track/${trackId}/reg`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        return resolve();
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject(error.response.data.info);
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function fetchTeams(
  token: string,
  contestId: number,
  trackId: number
): Promise<TeamFeedingForm> {
  return new Promise((resolve, reject) => {
    http
      .get(`/api/competition/${contestId}/track/${trackId}/team`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve(response.data as TeamFeedingForm);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function fetchOneTrack(
  // token: string,
  contestId: number,
  trackId: number
): Promise<TrackModel> {
  return new Promise((resolve, reject) => {
    http
      .get(`/api/competition/${contestId}/track/${trackId}`, {
        // headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve(response.data as TrackModel);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function fetchTracks(
  // token: string,
  contestId: number
): Promise<TrackModel[]> {
  return new Promise((resolve, reject) => {
    http
      .get(`/api/competition/${contestId}/track`, {
        // headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve(response.data.data as TrackModel[]);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function fetchHomeTrack(
  // token: string
): Promise<TrackModel[]> {
  return new Promise((resolve, reject) => {
    http
      .get(`/api/track`, {
        // headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve(response.data.data as TrackModel[]);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}
